import { Box, IconButton, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import NotesEditor from '../../pages/notes/NotesEditor';
import '../../assets/css/Text-General.css';

export const NOTES_PANEL_WIDTH = 400;

interface DealNotesPanelProps {
  title: string;
  dealId: number | null;
  onClose?: () => void;
}

export function DealNotesPanelHeader({
  title,
  onClose,
}: {
  title: string;
  onClose?: () => void;
}) {
  return (
    <Box
      sx={{
        // Same height as the Pipeline's search/filter row, so the panel lines up.
        height: 52,
        px: 2,
        borderBottom: '1px solid',
        borderColor: 'divider',
        backgroundColor: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        flexShrink: 0,
      }}
    >
      <Typography
        title={title}
        noWrap
        sx={{
          minWidth: 0,
          fontFamily: '"Helvetica Neue", sans-serif',
          fontSize: 14,
          fontWeight: 600,
          color: '#182737',
        }}
      >
        {title}
      </Typography>
      {onClose && (
        <IconButton onClick={onClose} size="small" aria-label="Close panel" sx={{ color: 'text.secondary' }}>
          <Close fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
}

export const DealNotesPanel = ({ title, dealId, onClose }: DealNotesPanelProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        backgroundColor: '#f2f5f9',
      }}
    >
      <DealNotesPanelHeader title={title} onClose={onClose} />
      <Box sx={{ flex: 1, overflow: 'auto', minHeight: 0, backgroundColor: '#f2f5f9', p: 2 }}>
        {dealId == null ? (
          <Typography color="text.secondary" variant="body2">
            Select a deal to view notes.
          </Typography>
        ) : (
          <NotesEditor key={dealId} dealId={dealId} />
        )}
      </Box>
    </Box>
  );
};
